import groq from "groq"

export const visitReportProjection = () => groq`
  "id": _id,
  "rev": _rev,
  customerNumber,
  contactName,
  attendanceAt,
  attendanceStart,
  attendanceEnd,
  meetingName,
  occasions[]->{name, label, "id": _id },
  mailRecipients,
  mailSubject,
  text,
  attachments[]{"id": _key, name, size},
  attachmentReferences[]{"id": _key, name, size, asset, url, mimetype},
`

export const visitReportAttachmentsProjection = () => groq`
  "id": _id,
  customerNumber,
  attachments[_key == $attachmentKey] {
    "id": _key,
    name,
    size,
    base64String,
    mimetype
  }
`
